import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Router } from '@angular/router';
import { ACLService } from '@delon/acl';
import { QUINNY_AI_AVATAR_URL } from '@core';
import { FcwidgetService } from 'src/app/core/util/fcwidget.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'header-chat',
  templateUrl: './quinny-ai.component.html',
  styleUrls: ['./quinny-ai.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule]
})
export class HeaderQuinnyAIComponent {
  readonly quinnyAiAvatarUrl = QUINNY_AI_AVATAR_URL;
  readonly noPermissionTip = 'You do not have permission';

  mobileOrTablet = input<boolean>(false);

  constructor(
    private readonly fcWidget: FcwidgetService,
    private readonly router: Router,
    private readonly acl: ACLService
  ) {}

  get hasAiEnabled(): boolean {
    return this.acl.canAbility('ai.enabled');
  }

  get hasQuinnyAI(): boolean {
    if (!this.hasAiEnabled) {
      return false;
    }

    return (
      this.canViewAssistant ||
      this.canViewReportAnalyzer ||
      this.canViewReportDesignerAI ||
      this.canViewFinancialAdvisor ||
      this.canViewConnections
    );
  }

  get canViewAssistant(): boolean {
    return this.acl.canAbility('quinny-ai-assistant.view');
  }

  get canViewReportAnalyzer(): boolean {
    return (
      this.acl.canAbility('quinny-ai-report-analyzer.view') &&
      this.acl.canAbility('report.view')
    );
  }

  get canViewReportDesignerAI(): boolean {
    return (
      this.acl.canAbility('quinny-ai-report-designer.view') &&
      this.acl.canAbility('reportfile.view')
    );
  }

  get canViewFinancialAdvisor(): boolean {
    return this.acl.canAbility('quinny-ai-financial-advisor.view');
  }

  get canViewConnections(): boolean {
    return this.acl.canAbility('quinny-ai-connections.view');
  }

  openChat() {
    const chatbot = document.getElementById('chatbot-window');
    if (chatbot?.classList.contains('visible')) {
      chatbot.classList.toggle('visible');
    }
    this.fcWidget.openWithUserContext();
  }

  navigateToAI(route: string) {
    this.router.navigate([route]);
  }
}
